import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';

import MainPagetitle from '../../layouts/MainPagetitle';
import { Modal, Button } from 'react-bootstrap';
import AdminVehicleService from '../../api/services/AdminVehicleService';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
const EditVehicle = () => {
  var imageUrl = process.env.REACT_APP_LARAVEL_IMAGE_URL;
  const params = useParams();
  const [error, setError] = useState("")
  const [drivingModal, setDrivingModal] = useState(false);
  const [driving, setDriving] = useState([]);
  const [file, setFile] = useState()
  const [isLoading, setisloading] = useState(true);
  useEffect(() => {
    var id = params.id;
    getDrivingByID(id);
  }, []);

  const getDrivingByID = async (id) => {
    try {
      let driving = await AdminVehicleService.show(id).json();
      setDriving(driving.data);
      setisloading(false);
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };
  const onFileChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var icon = fileReader.result
      setFile(icon)
    }
  }

  const onSubmit = async (event) => {
    event.preventDefault();
    setError("")
    try {
      var userData = {
        "title": event.target.title.value,
        "de_title": event.target.de_title.value,
        "icon": file ? file.split(',')[1] : "",
      }
      let responseData = await AdminVehicleService.update(params.id, userData).json()
      if (responseData.status === true) {
        setDrivingModal(true)
      }
    } catch (error) {
      console.log(error)
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };

  return (
    <>
      <MainPagetitle mainTitle="Vehicle" pageTitle={'Vehicle'} parentTitle={'Home'} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Edit Vehicle</h4>
              </div>
              <div className="card-body">
                <form className="form-valide" onSubmit={onSubmit}>
                  <div className="row">
                    <h5 style={{ color: 'red' }}>{error}</h5>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='title' id="val-username"
                        defaultValue={
                          driving.title
                            ? driving.title
                            : ''
                        } />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_title' id="val-username" placeholder="" defaultValue={
                        driving.de_title
                          ? driving.de_title
                          : ''
                      } />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">Icon <span className="text-danger">*</span></label>
                      {driving.icon ? <img className="img-drop-area" height={100} width={100} name="icon" src={file ? file : imageUrl + "Vehicle/" + driving.icon} alt='' /> : null}
                      <input type="file" className="form-control" name='icon' accept="image/png, image/jpeg, image/svg+xml" onChange={onFileChange} />
                    </div>
                  </div>
                  <div>
                    <button type="submit" className="btn btn-primary mb-2 me-1"  >Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <LogoAnimationLoader />}
      <Modal centered className="mark-attendence" show={drivingModal}>
        <Modal.Header>
          <Modal.Title>Update </Modal.Title>
          <Button variant="" className="btn-close" onClick={() => setDrivingModal(false)}></Button>
        </Modal.Header>
        <Modal.Body>Update Vehicle Successfully!!!.</Modal.Body>
        <Modal.Footer>
          <Link className="btn btn-primary" to='/admin/vehicle' variant="danger light" onClick={() => setDrivingModal(false)}>Close</Link>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default EditVehicle;